import type Company from '@simplywallst/services/lib/endpoints/types/company/Company';
import type { ReactNode } from 'react';
import DelistedSVG from './assets/DelistedSVG.svg';
import MergedSVG from './assets/MergedSVG.svg';

export type StatusClassificationSummary = {
  readonly title: ReactNode;
  readonly description: ReactNode;
  readonly graphic: SvgrComponent | null;
};

export function getStatusClassificationSummary(
  classification: Company['classification_status']
): StatusClassificationSummary | null {
  switch (classification) {
    default:
      return null;
    case 'inactive':
      return {
        title: 'This company is no longer active',
        description:
          'The company may no longer be operating, as it may be out of business. Find out why through their latest events.',
        graphic: DelistedSVG,
      };
    case 'merged':
      return {
        title: 'This company has been acquired',
        description:
          'The company may no longer be operating, as it has been acquired. Find out why through their latest events.',
        graphic: MergedSVG,
      };
    case 'active_not_trading':
      return {
        title: 'This company listing is no longer active',
        description:
          'This company may still be operating, however this listing is no longer active. Find out why through their latest events.',
        graphic: DelistedSVG,
      };
  }
}
